







import { Component, Vue, Watch } from 'vue-property-decorator';
import Layer from '@/components/service/InsLayer.vue';
import { FrontE } from '@/sdk/common/SysConst';

@Component({
  components: {
    Layer
  }
})
export default class App extends Vue {
  // 建站中跳转
  beforeCreate () {
    if (((FrontE.pcBuilding && this.userAgent === 'pc') || (FrontE.mobileBuilding && this.userAgent === 'mobile')) && this.$route.name !== 'building') {
      this.$store.dispatch('setOrgPath', this.$route.path);
      this.$router.push('/building');
    }
  }

  beforeUpdate () {
    if (this.$route.query.returnUrl) {
      let url = this.$route.query.returnUrl + '?';
      Object.keys(this.$route.query).forEach((e) => {
        if (e !== 'returnUrl') url += e + '=' + this.$route.query[e] + '&';
      });
      this.$router.push(url);
    }
  }

  // 设置 rem 函数
  setRem (base) {
    let width = document.documentElement.clientWidth;
    const newFont = (width / base) * 10;
    document.documentElement.style.fontSize = newFont + 'px';
  }

  get isMobile () {
    return this.$store.state.isMobile;
  }

  created () {
    if (window.innerWidth < 481) {
      this.$store.dispatch('setIsMobile', true);
      this.setRem(320);
    } else if (window.innerWidth < 769) {
      this.setRem(550);
      this.$store.dispatch('setIsMobile', true);
    } else {
      this.$store.dispatch('setIsMobile', false);
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth < 481) {
        this.$store.dispatch('setIsMobile', true);
        this.setRem(320);
      } else if (window.innerWidth < 769) {
        this.$store.dispatch('setIsMobile', true);
        this.setRem(550);
      } else {
        this.$store.dispatch('setIsMobile', false);
        document.documentElement.style.fontSize = '';
      }
    });
  }

  @Watch('isMobile', { deep: true })
  onMediaChange () {
    if (((FrontE.pcBuilding && !this.isMobile) || (FrontE.mobileBuilding && this.isMobile)) && this.$route.name !== 'building') {
      this.$store.dispatch('setOrgPath', this.$route.path);
      this.$router.push('/building');
    } else if (this.$route.name === 'building') {
      this.$router.push(this.$store.state.orgPath);
    }
  }
  mounted () {
    Vue.prototype.$ShowLayer();
    setTimeout(() => { Vue.prototype.$HiddenLayer(); }, 2000);
  }
}
